<div
    class="add-control"
    [class]="sideClass()"
    [class.fullWidthBlock]="isFullWidthBlock()"
    [style.opacity]="isShown() ? 1 : 0"
    [style.visibility]="isShown() ? 'visible' : 'hidden'"
>
    <button class="add-btn" [tooltip]="tooltipText()" [adaptivePosition]="true" (click)="onClick()">
        <span class="sp-icon icon-plus-add"> </span>
    </button>
</div>
